/**
 * Created by Alex Aguilar on 4/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('fuelTypeService', fuelTypeService);

    fuelTypeService.$inject = ['$http', 'CONFIG', 'messageService'];

    function fuelTypeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/fuelTypes';
        var service = {
            getFuelTypes: getFuelTypes
        }

        return service;

        function getFuelTypes(){
            return $http.get(urlBase)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }
    }
})();

